import React from "react"
import moment from "moment"
import { supplierItemTypes, productTypeToAdd } from "./supplierItemUtils"
import _cloneDeep from "lodash/cloneDeep"
import { groupBy } from "lodash"
import { roundNumber } from "../utils"
import { getStockUnitWeight } from "./ordersUtils"
import { getStockZone } from "../parseManager/site/parseSiteManager"
import { getDistributionCentersById } from "../parseManager/distributionCenters/distributionCentersManager"
import dayjs from "dayjs"

export const LOT_INVENTORY_MODE = "INVENTORY"
export const LOT_HISTORY_MODE = "HISTORY"
export const LOT_OUTPUT_MODE = "OUTPUT"
export const LOT_DAMAGE_MODE = "BROKEN"
export const LOT_RECEPTION_MODE = "RECEPTION"
export const LOT_DISPATCH_MODE = "DISPATCH"
export const LOT_RETURN_MODE = "RETURN"
export const UNKNOWN_LOT_GROUP_ID = "unknownGroup"
export const UNKNOWN_LOT_PRODUCT_TYPE_ID = "unknownProductType"
export const LOT_DLC_EDITION = "EDITED_DLC"
export const LOT_STOCKZONE_EDITION = "EDITED_STOCKZONE"
export const LOT_LOTNUMBER_EDITION = "EDITED_LOTNUMBER"

export const LOT_EVENTS_MODES = [
  LOT_INVENTORY_MODE,
  LOT_RECEPTION_MODE,
  LOT_OUTPUT_MODE,
  LOT_RETURN_MODE,
  LOT_DAMAGE_MODE,
  LOT_DISPATCH_MODE,
  LOT_DLC_EDITION,
  LOT_STOCKZONE_EDITION,
  LOT_LOTNUMBER_EDITION
]

export const getEventDescription = async (event, remainingQuantity) => {
  switch (event.mode) {
    case "RECEPTION":
      return <span style={{ whiteSpace: "nowrap" }}>
        Réception de <strong>{formatArticleCount(remainingQuantity)}</strong>.
      </span>
    case "INVENTORY":
      return <span style={{ whiteSpace: "nowrap" }}>
        Inventaire de <strong>{formatArticleCount(remainingQuantity)}</strong>.
      </span>
    case "OUTPUT":
      return <span style={{ whiteSpace: "nowrap" }}>
        Sortie de <strong>{formatArticleCount(event.quantity)}</strong>, le stock restant est de <strong>{formatArticleCount(remainingQuantity)}</strong>.
      </span>
    case "RETURN":
      return <span style={{ whiteSpace: "nowrap" }}>
        Retour de <strong>{formatArticleCount(event.quantity)}</strong>, le stock restant est de <strong>{formatArticleCount(remainingQuantity)}</strong>.
      </span>
    case "DISPATCH": {
      const fullHub = await getDistributionCentersById(event.hub.objectId)
      return <span style={{ whiteSpace: "nowrap" }}>
        Dispatch de <strong>{formatArticleCount(event.quantity)}</strong> vers le hub <strong>{fullHub.name}</strong>.
      </span>
    }
    case "BROKEN":
      return <span style={{ whiteSpace: "nowrap" }}>
        Mise à la casse de <strong>{formatArticleCount(event.quantity)}</strong>, le stock restant est de <strong>{formatArticleCount(remainingQuantity)}</strong>.
      </span>
    case "EDITED_LOTNUMBER":
      return <span style={{ whiteSpace: "nowrap" }}>
        Changement du n° de lot {event.initialLotNumber} par <strong>{event.updatedLotNumber}</strong>.
      </span>
    case "EDITED_DLC":
      return <span style={{ whiteSpace: "nowrap" }}>
        Changement de la DLC {dayjs(event.initialDLC).format("DD/MM/YYYY")} au <strong>{dayjs(event.updatedDLC).format("DD/MM/YYYY")}</strong>.
      </span>
    case "EDITED_STOCKZONE": {
      const initialStockZone = event.initialStockZone.name ? event.initialStockZone : await getStockZone({ stockZoneId: event.initialStockZone.objectId })
      const updatedStockZone = event.updatedStockZone.name ? event.updatedStockZone :  await getStockZone({ stockZoneId: event.updatedStockZone.objectId })
      return <span style={{ whiteSpace: "nowrap" }}>
        Changement de la zone de stockage {initialStockZone.name} vers <strong>{updatedStockZone.name}</strong>.
      </span>
    }
    default:
      return ""
  }
}

const formatArticleCount = (count) => {
  return `${count} article${count > 1 ? "s" : ""}`
}

export const DLC_FILTER_TYPES = [
  { key: "PASSED", label: "DLC dépassée" },
  { key: "SHORT", label: "DLC courte" },
  { key: "STANDARD", label: "DLC standard" },
]

const isGroupedByProductType = (key) => {
  const splittedKey = key.split("-")
  const type = splittedKey[0]
  if (type === supplierItemTypes.SALABLE_PRODUCT.key) {
    return supplierItemTypes.SALABLE_PRODUCT.key
  } else if (type === supplierItemTypes.PACKAGING_CONSUMABLE.key) {
    return supplierItemTypes.PACKAGING_CONSUMABLE.key
  } else if (type === UNKNOWN_LOT_PRODUCT_TYPE_ID) {
    return UNKNOWN_LOT_PRODUCT_TYPE_ID
  }
}

export const getGroupIngredientNameFromId = (id, groupIngredients) => {
  const group = groupIngredients.find((el) => el.objectId === id)
  return group ? group.name : "Groupe inconnu"
}

// Get product type name to put in inventory and output headers
export const getSupplierItemTypeByKey = (key, productTypesOptions) => {
  if (key.split("_").shift() === "SALABLE") {
    const splittedKey = key.split("-")
    const productTypeKey = splittedKey[splittedKey.length - 1]
    const currentProductType = productTypesOptions.find(
      (el) => el.value === productTypeKey
    )
    const group = currentProductType ? currentProductType.label : "Inconnu"
    return group
  } else if (key.split("_").shift() === "PACKAGING") {
    const splittedKey = key.split("-")
    const productTypeKey = splittedKey[splittedKey.length - 1]
    const currentProductType = productTypeToAdd.find(
      (el) => el.value === productTypeKey
    )
    const group = currentProductType.value
    return group.replaceAll("_", " ")
  } else if (key.split("_").shift() === UNKNOWN_LOT_PRODUCT_TYPE_ID) {
    return "Anciens types de produit"
  }
}

export const getLotsGroupName = (
  key,
  groupIngredients,
  productTypesOptions
) => {
  const groupName = isGroupedByProductType(key)
    ? getSupplierItemTypeByKey(key, productTypesOptions)
    : getGroupIngredientNameFromId(key, groupIngredients)
  return groupName
}

export function getLotMode(path) {
  if (path.startsWith("/lotIventory")) {
    return LOT_INVENTORY_MODE
  } else if (path.startsWith("/lotOutput")) {
    return LOT_OUTPUT_MODE
  } else {
    return LOT_INVENTORY_MODE
  }
}

export function getLotFilterModeLabel(mode) {
  switch (mode) {
    case LOT_INVENTORY_MODE:
      return "pour accéder à l'inventaire"
    case LOT_OUTPUT_MODE:
      return "pour effectuer une sortie"
    default:
      return ""
  }
}

export const getParamsFromPath = (pathname) => {
  const paths = pathname.split("/")

  if (pathname.startsWith("/lotInventory/")) {
    return {
      stockZone: paths[2],
    }
  }

  if (
    pathname.startsWith("/lotOutput/") &&
    (paths.length === 4 || paths.length === 5)
  ) {
    return {
      stockZone: paths[2],
      date: moment.utc(parseFloat(paths[3])).startOf("day").valueOf(),
    }
  }

  return null
}

const groupLotsByCharacter = (lots) => {
  const lotsForGroup = new Map()
  const characters = lots.map((lot) =>
    lot.orderSupplierItem.name.trim().charAt(0).toUpperCase()
  )

  for (const char of characters) {
    const lotsForCharacter = lots.filter(
      (lot) =>
        lot.orderSupplierItem.name.trim().charAt(0).toUpperCase() ===
        char.toUpperCase()
    )
    lotsForGroup.set(char, lotsForCharacter)
  }
  return lotsForGroup
}

const isLotWithGroupIngredient = (lot, group) => {
  return (
    lot.orderSupplierItem &&
    lot.orderSupplierItem.commercialName &&
    lot.orderSupplierItem.commercialName.group &&
    lot.orderSupplierItem.commercialName.group.objectId === group.objectId
  )
}

const isLotWithoutGroupIngredient = (lot) =>
  lot.orderSupplierItem && !lot.orderSupplierItem.commercialName

const isWithoutValidProductType = (lot, productTypes) =>
  lot.orderSupplierItem &&
  lot.orderSupplierItem.productType &&
  !productTypes.find((el) => el.value === lot.orderSupplierItem.productType)

const isProductTypeWithGroupIngredient = (lot, type) =>
  lot.orderSupplierItem && lot.orderSupplierItem.productType === type.value

export const sortLots = (lotsData, groupIngredients, newLot, productTypes) => {
  const sortedLots = new Map()

  // --------------------------------------------------------------- //
  // ----------------- RAW MATERIAL SUPPLIER ITEMS ----------------- //
  // --------------------------------------------------------------- //

  const rawMaterialLots = lotsData.filter(
    (lot) =>
      lot.orderSupplierItem.type &&
      lot.orderSupplierItem.type === supplierItemTypes.RAW_MATERIAL.key
  )
  // lots with group
  for (const group of groupIngredients) {
    const lotsWithGroup = rawMaterialLots.filter((lot) =>
      isLotWithGroupIngredient(lot, group)
    )
    if (
      newLot &&
      newLot.orderSupplierItem.type === supplierItemTypes.RAW_MATERIAL.key &&
      isLotWithGroupIngredient(newLot, group) &&
      newLot.quantity === 0
    ) {
      lotsWithGroup.push(newLot)
    }
    if (lotsWithGroup.length > 0) {
      const lotsForGroup = groupLotsByCharacter(lotsWithGroup)
      sortedLots.set(group.objectId, lotsForGroup)
    }
  }

  // lot without group
  const lotsWithoutGroup = rawMaterialLots.filter((lot) =>
    isLotWithoutGroupIngredient(lot)
  )
  // lot to display manually even if quantity is 0
  if (
    newLot &&
    newLot.orderSupplierItem.type === supplierItemTypes.RAW_MATERIAL.key &&
    isLotWithoutGroupIngredient(newLot) &&
    newLot.quantity === 0
  ) {
    lotsWithoutGroup.push(newLot)
  }
  if (lotsWithoutGroup.length > 0) {
    const lotsForGroup = groupLotsByCharacter(lotsWithoutGroup)
    sortedLots.set(UNKNOWN_LOT_GROUP_ID, lotsForGroup)
  }

  // --------------------------------------------------------------- //
  // --------------- SALABLE PRODUCT SUPPLIER ITEMS ---------------- //
  // --------------------------------------------------------------- //
  const salableProductLots = lotsData.filter(
    (lot) =>
      lot.orderSupplierItem.type &&
      lot.orderSupplierItem.type === supplierItemTypes.SALABLE_PRODUCT.key &&
      lot.orderSupplierItem.productType
  )

  for (const type of productTypes) {
    const lotsWithGroup = salableProductLots.filter((lot) =>
      isProductTypeWithGroupIngredient(lot, type)
    )
    // lot to display manually even if quantity is 0
    if (
      newLot &&
      newLot.orderSupplierItem.type ===
        supplierItemTypes.PACKAGING_CONSUMABLE.key &&
      isProductTypeWithGroupIngredient(newLot, type) &&
      newLot.quantity === 0
    ) {
      lotsWithGroup.push(newLot)
    }
    if (lotsWithGroup.length > 0) {
      const lotsForGroup = groupLotsByCharacter(lotsWithGroup)
      sortedLots.set(
        supplierItemTypes.SALABLE_PRODUCT.key + "-" + type.value,
        lotsForGroup
      )
    }
  }

  const salableProductsLotsWithoutValidProductTypes = salableProductLots.filter(
    (lot) => isWithoutValidProductType(lot, productTypes)
  )

  if (salableProductsLotsWithoutValidProductTypes.length > 0) {
    const lotsForGroup = groupLotsByCharacter(
      salableProductsLotsWithoutValidProductTypes
    )
    sortedLots.set(UNKNOWN_LOT_PRODUCT_TYPE_ID, lotsForGroup)
  }

  // ---------------------------------------------------------------------- //
  // ------------ PACKAGING CONSUMABLE PRODUCT SUPPLIER ITEMS ------------- //
  // ---------------------------------------------------------------------- //
  const packagingConsumableProductLots = lotsData.filter(
    (lot) =>
      lot.orderSupplierItem.type &&
      lot.orderSupplierItem.type ===
        supplierItemTypes.PACKAGING_CONSUMABLE.key &&
      lot.orderSupplierItem.productType
  )

  for (const key of productTypeToAdd) {
    const lotsWithGroup = packagingConsumableProductLots.filter((lot) =>
      isProductTypeWithGroupIngredient(lot, key)
    )
    // lot to display manually even if quantity is 0
    if (
      newLot &&
      isProductTypeWithGroupIngredient(newLot, key) &&
      newLot.quantity === 0
    ) {
      lotsWithGroup.push(newLot)
    }
    if (lotsWithGroup.length > 0) {
      const lotsForGroup = groupLotsByCharacter(lotsWithGroup)

      sortedLots.set(
        supplierItemTypes.PACKAGING_CONSUMABLE.key + "-" + key.value,
        lotsForGroup
      )
    }
  }

  return sortedLots
}

export const filterLotsByGroupIngredient = (lotsData, filter) => {
  if (filter.length > 0) {
    for (const [key] of lotsData) {
      if (filter.filter((el) => el.value === key).length === 0) {
        lotsData.delete(key)
      }
    }
  }

  return lotsData
}

export const filterLotsBySearchValue = (lotsData, filter) => {
  const exp = new RegExp(filter.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), "i")

  for (const [group, value] of lotsData) {
    for (const [char, values] of value) {
      lotsData.get(group).set(
        char,
        [...values].filter((el) => exp.test(el.orderSupplierItem.name))
      )
      if (lotsData.get(group).get(char).length === 0) {
        lotsData.get(group).delete(char)
      }
    }
    if (lotsData.get(group).size === 0) {
      lotsData.delete(group)
    }
  }

  return lotsData
}

export const filterSecondaryDLCsByDlc = (
  secondaryDlcData,
  filter,
  currentDate,
  warningDate
) => {
  for (const [group, value] of secondaryDlcData) {
    for (const [char, values] of value) {
      let filteredSecondaryDlCs = []

      if (filter.includes("ALL")) {
        filteredSecondaryDlCs = [...values]
      } else {
        if (filter.includes("PASSED")) {
          const elements = values.filter((el) => el.secondaryDLC < currentDate)
          filteredSecondaryDlCs.push(...elements)
        }

        if (filter.includes("SHORT")) {
          const elements = values.filter(
            (el) =>
              currentDate <= el.secondaryDLC && el.secondaryDLC <= warningDate
          )
          filteredSecondaryDlCs.push(...elements)
        }

        if (filter.includes("STANDARD")) {
          const elements = values.filter((el) => el.secondaryDLC > warningDate)
          filteredSecondaryDlCs.push(...elements)
        }
      }

      if (filteredSecondaryDlCs.length > 0) {
        secondaryDlcData.get(group).set(char, filteredSecondaryDlCs)
      } else {
        secondaryDlcData.get(group).delete(char)
      }
    }
  }
  return secondaryDlcData
}

export const filterLotsByDlc = (
  lotsData,
  filter,
  currentDate,
  warningDate,
  isInventory = false
) => {
  for (const [group, value] of lotsData) {
    for (const [char, values] of value) {
      let filteredLots = []

      if (filter.includes("ALL")) {
        if (isInventory) {
          filteredLots = [...values]
        } else {
          // display lots that:
          // - have stock
          // - or don't have stock but have output event with production date equal to current date (the date selected on the UI)
            filteredLots = values.filter((el) => {
            const hasValidDlc = el.dlc >= currentDate
            const hasStock = el.quantity > 0
            const hasOutputOnTime = el.events?.some(
              (event) =>
              event.mode === LOT_OUTPUT_MODE &&
              dayjs(event.productionDate).diff(currentDate, "day") === 0
            )
            return hasValidDlc && (hasStock || !!hasOutputOnTime)
          })
        }
      } else {
        if (filter.includes("PASSED")) {
          const elements = values.filter((el) => el.dlc < currentDate)
          filteredLots.push(...elements)
        }

        if (filter.includes("SHORT")) {
          const elements = values.filter(
            (el) => currentDate <= el.dlc && el.dlc <= warningDate
          )
          filteredLots.push(...elements)
        }

        if (filter.includes("STANDARD")) {
          const elements = values.filter((el) => el.dlc > warningDate)
          filteredLots.push(...elements)
        }
      }

      if (filteredLots.length > 0) {
        lotsData.get(group).set(char, filteredLots)
      } else {
        lotsData.get(group).delete(char)
      }
    }

    if (lotsData.get(group).size === 0) {
      lotsData.delete(group)
    }
  }
  return lotsData
}

const getRelatedOutput = (outputLeft, supplierItemId) =>
  outputLeft.filter((inventory) => inventory.ingredientId === supplierItemId)

export const filterQuantityOutput = (
  lotsData,
  outputInventoryData,
  date,
  mode
) => {
  for (const [, value] of lotsData) {
    for (const [, values] of value) {
      const originalOutputLeft = _cloneDeep(outputInventoryData)
      let outputLeft = _cloneDeep(outputInventoryData)

      values.sort((a, b) => (a.dlc < b.dlc ? -1 : 1))

      // we calculate all output already done by supplier item id
      const quantityAlreadyOutputBySupplierItem = {}
      // same, in stock units, for the "already output" note
      const unitsAlreadyOutputBySupplierItem = {}
      values.forEach((lot) => {
        const eventsOutput =
          lot.events && lot.events.length > 0
            ? lot.events.filter(
                (event) =>
                  event.mode === "OUTPUT" && event.productionDate === date
              )
            : []
        unitsAlreadyOutputBySupplierItem[lot.orderSupplierItem.supplierItemId] =
          (unitsAlreadyOutputBySupplierItem[lot.orderSupplierItem.supplierItemId] || 0) +
          eventsOutput.reduce((total, event) => total + event.quantity, 0)
        if (
          !quantityAlreadyOutputBySupplierItem[
            lot.orderSupplierItem.supplierItemId
          ]
        ) {
          quantityAlreadyOutputBySupplierItem[
            lot.orderSupplierItem.supplierItemId
          ] = 0
        }

        quantityAlreadyOutputBySupplierItem[
          lot.orderSupplierItem.supplierItemId
        ] = eventsOutput
          .map((event) => event.quantity)
          .reduce((a, b) => {
            return a + b * lot.orderSupplierItem.units.stock.weight
          }, quantityAlreadyOutputBySupplierItem[lot.orderSupplierItem.supplierItemId])
      })

      values.forEach((currentValue) => {
        //we get the quantity already output for the current value
        const currentQuantityAlreadyOutput =
          quantityAlreadyOutputBySupplierItem &&
          quantityAlreadyOutputBySupplierItem[
            currentValue.orderSupplierItem.supplierItemId
          ]
            ? quantityAlreadyOutputBySupplierItem[
                currentValue.orderSupplierItem.supplierItemId
              ]
            : 0
        let outputInventoryRelated = getRelatedOutput(
          outputLeft,
          currentValue.orderSupplierItem.supplierItemId
        )
        const originalRelatedOutputInventory = getRelatedOutput(
          originalOutputLeft,
          currentValue.orderSupplierItem.supplierItemId
        )
        let outputWeight = 0
        outputInventoryRelated.forEach((outputInventory) => {
          outputWeight += outputInventory.weight
        })

        currentValue.hasAlreadyQuantityOutput =
          currentQuantityAlreadyOutput > 0
        /** outputWeight = La quantité qu'on DOIT sortir **/
        outputWeight -= currentQuantityAlreadyOutput // we decrease the output already done

        let totalOutputWeight = 0
        originalRelatedOutputInventory.forEach(
          (inventory) => (totalOutputWeight += inventory.weight)
        )
        currentValue.quantityOutput = 0 // Quantité restante à sortir

        //totalOutputWeight = Le besoin total à sortir
        currentValue.totalOutputWeight =
          originalRelatedOutputInventory.length > 0
            ? totalOutputWeight - currentQuantityAlreadyOutput
            : 0

        // gross weight of the day's need (same as the traceability voucher), shown under the output quantity
        currentValue.outputNeed =
          originalRelatedOutputInventory.length > 0
            ? getOutputNeed(
                originalRelatedOutputInventory,
                currentQuantityAlreadyOutput,
                unitsAlreadyOutputBySupplierItem[currentValue.orderSupplierItem.supplierItemId] || 0
              )
            : null
        if (outputWeight > 0) {
          /** quantityWeight = Quantité DISPONIBLE **/
          let quantityWeight =
            currentValue.quantity *
            currentValue.orderSupplierItem.units.stock.weight
          // if the quantity available is < than all weight we need to output
          if (quantityWeight < outputWeight) {
            currentValue.quantityOutput =
              quantityWeight > 0
                ? roundNumber(
                    quantityWeight /
                      currentValue.orderSupplierItem.units.stock.weight,
                    1
                  )
                : 0
            outputWeight -= quantityWeight
            outputLeft = reduceQuantityWeightLeft(
              outputLeft,
              currentValue.orderSupplierItem.supplierItemId,
              quantityWeight
            )
          } else {
            let quantityOutput = Math.ceil(
              outputWeight / currentValue.orderSupplierItem.units.stock.weight
            )
            //if the quantity to output is bigger than what we have in stock, we just output the remaining stock
            quantityOutput =
              quantityOutput <= currentValue.quantity
                ? quantityOutput
                : currentValue.quantity
            currentValue.quantityOutput =
              quantityOutput > 0 ? quantityOutput : 0
            outputWeight = 0
            outputLeft = reduceQuantityWeightLeft(
              outputLeft,
              currentValue.orderSupplierItem.supplierItemId,
              -1
            )
          }
        }
      })
    }
  }

  lotsData = removeLotsNotNeeded(lotsData, mode)

  return lotsData
}

export const removeLotsNotNeeded = (lotsData, mode) => {
  for (const [group, value] of lotsData) {
    for (const [char, values] of value) {
      let lotsToDisplay = []
      if (mode === LOT_OUTPUT_MODE) {
        lotsToDisplay = values.filter(
          (elm) => elm.hasAlreadyQuantityOutput || elm.quantity > 0
        )
      } else {
        lotsToDisplay = values.filter((elm) => elm.quantity > 0)
      }

      lotsData.get(group).set(
        char,
        [...values].filter(
          (el) =>
            typeof lotsToDisplay.find(
              (elem) => elem.objectId === el.objectId
            ) !== "undefined"
        )
      )
      if (lotsData.get(group).get(char).length === 0) {
        lotsData.get(group).delete(char)
      }
    }

    if (lotsData.get(group).size === 0) {
      lotsData.delete(group)
    }
  }

  return lotsData
}
const generateHypotheticalLotId = (lot) => {
  return lot.objectId + lot.dlc + lot.lotNumber
}

export const compareLots = (lot1, lot2) => {
  if (lot1.orderSupplierItem.name < lot2.orderSupplierItem.name) {
    return -1
  } else if (lot1.orderSupplierItem.name > lot2.orderSupplierItem.name) {
    return 1
  } else {
    return lot1.dlc < lot2.dlc ? -1 : 1
  }
}

export const compareSecondaryDLCs = (secondaryDLC1, secondaryDLC2) => {
  if (
    secondaryDLC1.orderSupplierItem.name < secondaryDLC2.orderSupplierItem.name
  ) {
    return -1
  } else if (
    secondaryDLC1.orderSupplierItem.name > secondaryDLC2.orderSupplierItem.name
  ) {
    return 1
  } else {
    return secondaryDLC1.secondaryDLC < secondaryDLC2.secondaryDLC ? -1 : 1
  }
}

export const isLotOrSecondaryDLCCardSelected = (selectedCard, card) => {
  if (!selectedCard) return false

  if (selectedCard.hypothetical) {
    const selectedCardId = generateHypotheticalLotId(selectedCard)
    const cardId = generateHypotheticalLotId(card)
    return selectedCardId === cardId
  }

  return card.objectId === selectedCard.objectId
}

/**
 * Convert a missing weight (kg) into a whole number of stock units, rounded up:
 * an operator cannot output a fraction of a piece (same rule as real lots).
 * Rounding to 2 decimals first absorbs float noise (68.0000001 must stay 68).
 */
export const getMissingStockUnits = (missingWeight, stockUnitWeight) =>
  Math.ceil(roundNumber(missingWeight / stockUnitWeight, 2))

// release voucher type grouping desserts, breakfast, fruits, viennoiseries and cut products
const PASTRY_OUTPUT_TYPE = "B+D"

/**
 * Split the day's need (kg) of a supplier item between pastry and kitchen recipes,
 * from its output inventory rows (one row per release voucher type).
 * Rows without type (production needs mode) cannot be split: pastry and kitchen are null.
 */
export const getOutputNeedByType = (outputInventoryRows) => {
  const isTyped = outputInventoryRows.every((row) => row.type)
  const need = { total: 0, pastry: isTyped ? 0 : null, kitchen: isTyped ? 0 : null }

  outputInventoryRows.forEach((row) => {
    need.total += row.weight || 0
    if (!isTyped) return
    if (row.type === PASTRY_OUTPUT_TYPE) {
      need.pastry += row.weight || 0
    } else {
      need.kitchen += row.weight || 0
    }
  })

  return {
    total: roundNumber(need.total, 3),
    pastry: isTyped ? roundNumber(need.pastry, 3) : null,
    kitchen: isTyped ? roundNumber(need.kitchen, 3) : null,
  }
}

/**
 * Need of the day (kg) of a supplier item, its split by destination, what was already output
 * and what remains to output: the output quantity of the page is computed on the remaining need
 */
export const getOutputNeed = (outputInventoryRows, alreadyOutput, alreadyOutputUnits) => {
  const need = getOutputNeedByType(outputInventoryRows)
  return {
    ...need,
    alreadyOutput,
    alreadyOutputUnits,
    remaining: roundNumber(Math.max(0, need.total - alreadyOutput), 3),
  }
}

/**
 * Weight shown to the operators on the output page: grams under 1 kg,
 * otherwise kg rounded to 2 decimals with a dot, like the rest of the page and the traceability voucher
 */
export const formatOutputWeight = (weight) => {
  if (weight < 1) return `${Math.round(weight * 1000)} g`
  return `${roundNumber(weight, 2)} kg`
}

export const formatLotOrSecondaryDLCCard = (
  document,
  collection,
  mode,
  currentDate
) => {
  if (collection === "Lot") {
    const lot = document
    const formattedLot = {
      collection,
      name: lot.orderSupplierItem.name,
      dlc: dayjs(lot.dlc).format("DD/MM/YYYY"),
      dlcTimestamp: lot.dlc,
      lotNumber: lot.lotNumber,
      quantity: lot.quantity,
      quantityOutput: lot.quantityOutput,
      hasAlreadyQuantityOutput: lot.hasAlreadyQuantityOutput,
      unit: getStockUnitWeight(lot.orderSupplierItem),
      weight:
        lot.orderSupplierItem.units &&
        lot.orderSupplierItem.units.stock &&
        lot.orderSupplierItem.units.stock.weight,
      hypothetical: lot.hypothetical,
    }

    const dates =
      mode === LOT_INVENTORY_MODE
        ? (document &&
            document.events &&
            document.events
              .filter((e) => e.mode === "INVENTORY")
              .map(
                (e) => e.date && dayjs.utc(e.date).startOf("day").valueOf()
              )) ||
          []
        : (document &&
            document.events &&
            document.events
              .filter(
                (e) => e.mode === "OUTPUT" && e.productionDate === currentDate
              )
              .map(
                (e) => e.date && dayjs.utc(e.date).startOf("day").valueOf()
              )) ||
          []

    const isUpdated = dates.includes(dayjs.utc().startOf("day").valueOf())

    formattedLot.isUpdated = isUpdated

    const isGrey = document.display ? false : +document.quantity === 0
    formattedLot.isGrey = isGrey

    if (lot.hypothetical) {
      if (formattedLot.weight) {
        formattedLot.quantityOutput = getMissingStockUnits(lot.quantityOutput, formattedLot.weight)
      } else {
        formattedLot.unit = "Kg"
      }
    }
    return formattedLot
  }
  if (collection === "SecondaryDLC") {
    const secondaryDLC = document
    const events = (document.events || []).map(
      (e) => e.date && dayjs.utc(e.date).startOf("day").valueOf()
    )
    // is updated =events contain today
    const isUpdated = events.includes(dayjs.utc().startOf("day").valueOf())
    return {
      collection,
      name: secondaryDLC.name,
      dlc: dayjs(secondaryDLC.secondaryDLC).format("DD/MM/YYYY"),
      dlcTimestamp: secondaryDLC.secondaryDLC,
      lotNumber: secondaryDLC.lotNumber,
      quantity: secondaryDLC.quantity,
      unit: "Kg",
      isUpdated,
    }
  }
  return document
}

/**
 * hypothetical lots for remaining quantity
 * productionItems expectedProduction for each recipe - total of quantityOutput of lots (with the same supplierItem)
 * @param {*} lotsData
 * @param {*} outputInventoryData
 * @param {*} stockZone
 * @param {*} allSubstituteLots
 * @param {*} date
 * @param {*} supplierItemsHypotheticalTreated
 * @returns
 */
export const addHypotheticalOutputLots = (
  lotsData,
  outputInventoryData,
  stockZone,
  allSubstituteLots,
  date,
  supplierItemsHypotheticalTreated
) => {
  const lots = _cloneDeep(lotsData)
  const supplierItemIds = []
  for (const [group, value] of lots) {
    for (const [char, values] of value) {
      values.forEach((elm) =>
        supplierItemIds.push(elm.orderSupplierItem.supplierItemId)
      )
      const groupedLotsBySupplierItem = groupBy(
        values,
        "orderSupplierItem.supplierItemId"
      )
      for (const groupedLots of Object.values(groupedLotsBySupplierItem)) {
        // total of the quantityOutput of the displayed outputted lots
        // with testing the first item we can be sure to have any item in the array
        // because below we use the last item as hypothetical lot
        if (groupedLots[0] && groupedLots[0].totalOutputWeight !== null) {
          let totalQuantityOutput = 0
          for (const lot of groupedLots) {
            if (
              lot.orderSupplierItem.units &&
              lot.orderSupplierItem.units.stock
            ) {
              totalQuantityOutput +=
                lot.quantityOutput * lot.orderSupplierItem.units.stock.weight
            }
          }

          // use the last item as copy to respect the order
          // if order is not important, we can copy any item in the array as hypothetical lot
          const lastGroupedLot = groupedLots[groupedLots.length - 1]
          const quantityMissing =
            lastGroupedLot?.totalOutputWeight - totalQuantityOutput
          if (
            quantityMissing > 0 &&
            (!stockZone ||
              lastGroupedLot.stockZone.objectId === stockZone.objectId)
          ) {
            const supplierItemHypothetical =
              supplierItemsHypotheticalTreated.find(
                (supplierItemHypothetical) =>
                  supplierItemHypothetical.objectId ===
                  lastGroupedLot.orderSupplierItem.supplierItemId
              )
            const hasBeenTreated =
              supplierItemHypothetical &&
              supplierItemHypothetical.hypotheticalLotsTreated.find(
                (hypotheticalLot) =>
                  hypotheticalLot.stockZoneId ===
                    lastGroupedLot.stockZone.objectId &&
                  hypotheticalLot.date === date
              )
            if (!hasBeenTreated) {
              let quantitySubstituteOutput = getQuantitySubstituteAlreadyOutput(
                allSubstituteLots,
                lastGroupedLot.orderSupplierItem.supplierItemId,
                date
              )
              const newGroupedLots = [
                ...groupedLots,
                {
                  ...lastGroupedLot,
                  objectId: generateHypotheticalLotId(lastGroupedLot),
                  hypothetical: true,
                  // copy the last item
                  quantityOutput: roundNumber(
                    quantityMissing - quantitySubstituteOutput,
                    2
                  ),
                  hasAlreadyQuantityOutput: false,
                },
              ]

              const mergedLots = [
                ...lots.get(group).get(char),
                ...newGroupedLots,
              ]
              lots.get(group).set(
                char,
                mergedLots.filter(
                  (lot, index) => mergedLots.indexOf(lot) === index
                )
              )
            }
          }
        }
      }
    }
  }

  // handle hypothetical lot without existing similar lot
  const rawOutputInventoryDataLeft = outputInventoryData.filter((elm) => {
    const supplierItemHypothetical = supplierItemsHypotheticalTreated.find(
      (supplierItemHypothetical) =>
        supplierItemHypothetical.objectId === elm.ingredientId
    )
    const hasBeenTreated =
      supplierItemHypothetical &&
      supplierItemHypothetical.hypotheticalLotsTreated.find(
        (hypotheticalLot) =>
          hypotheticalLot.stockZoneId === stockZone.objectId &&
          hypotheticalLot.date === date
      )

    const include = (
      !supplierItemIds.includes(elm.ingredientId) &&
      elm.nbUnit > 0 &&
      (!stockZone || elm.storageArea === stockZone.name) &&
      !hasBeenTreated
    )

    return include
  })

  // concat nb unit of same ingredient id separated into different product type in one
  const outputInventoryDataLeft = Object.values(
    rawOutputInventoryDataLeft.reduce(
      (acc, { ingredientId, ingredientName, weight, units }) => {
        const unitWeightMissing =
          units && units.stock ? weight : 1
        
        acc[ingredientId] = {
          ingredientId,
          ingredientName,
          nbUnit:
            (acc[ingredientId] ? acc[ingredientId].nbUnit : 0) +
            unitWeightMissing,
          units,
        }
        return acc
      },
      {}
    )
  )

  if (outputInventoryDataLeft.length > 0 && lots.size >= 0) {
    const formattedOutputInventoryLeft = outputInventoryDataLeft.map(
      ({ ingredientId, ingredientName, nbUnit, units }) => {
        let quantitySubstituteOutput = getQuantitySubstituteAlreadyOutput(
          allSubstituteLots,
          ingredientId,
          date
        )

        return {
          objectId: ingredientId,
          supplierItemId: ingredientId,
          orderSupplierItem: {
            name: ingredientName,
            units,
            supplierItemId: ingredientId,
            type: "RAW_MATERIAL",
          },
          hypothetical: true,
          quantity: roundNumber(nbUnit - quantitySubstituteOutput, 2),
          quantityOutput: roundNumber(nbUnit - quantitySubstituteOutput, 2),
          hasAlreadyQuantityOutput: false,
          stockZone: stockZone,
        }
      }
    )

    const lotsForGroup = new Map()
    const characters = formattedOutputInventoryLeft.map((lot) =>
      lot.orderSupplierItem.name.trim().charAt(0).toUpperCase()
    )
    for (const char of characters) {
      const lotsForCharacter = formattedOutputInventoryLeft.filter(
        (lot) =>
          lot.orderSupplierItem.name.trim().charAt(0) === char.toUpperCase()
      )
      lotsForGroup.set(char, lotsForCharacter)
    }

    lots.set(UNKNOWN_LOT_GROUP_ID, lotsForGroup)
  }

  return lots
}

export const reduceQuantityWeightLeft = (
  outputLeft,
  supplierItemId,
  quantityWeightToReduce
) => {
  const outputInventoryRelated = outputLeft.filter(
    (inventory) => inventory.ingredientId === supplierItemId
  )
  outputInventoryRelated.forEach((outputInventory) => {
    // -1 means there is not output inventory left
    if (quantityWeightToReduce === -1) {
      outputInventory.weight = 0
    } else {
      if (outputInventory.weight >= quantityWeightToReduce) {
        outputInventory.weight -= quantityWeightToReduce
        quantityWeightToReduce = 0
      } else {
        quantityWeightToReduce -= outputInventory.weight
        outputInventory.weight = 0
      }
    }
  })

  return outputLeft
}

export const filteredOutputLots = (
  lotsData,
  outputInventoryData,
  selectedDate
) => {
  const supplierItemsIds = outputInventoryData?.map(
    (supplierItem) => supplierItem.ingredientId
  )

  if (supplierItemsIds.length > 0) {
    for (const [group, value] of lotsData) {
      for (const [char, values] of value) {
        lotsData.get(group).set(
          char,
          [...values].filter((el) => {
            if (el.quantityOutput <= 0) return false

            return (
              (el.hypothetical ||
                (supplierItemsIds.includes(
                  el.orderSupplierItem.supplierItemId
                ) &&
                  el.quantity > 0)) &&
              (el.quantityOutput > 0 ||
                el.events.filter(
                  (e) =>
                    e.mode === "OUTPUT" && e.productionDate === selectedDate
                ).length > 0)
            )
          })
        )
        if (lotsData.get(group).get(char).length === 0) {
          lotsData.get(group).delete(char)
        }
      }
      if (lotsData.get(group).size === 0) {
        lotsData.delete(group)
      }
    }
  } else {
    lotsData = []
  }

  return lotsData
}

export const filterOnRawMaterial = (lotsData) => {
  for (const [group, value] of lotsData) {
    for (const [char, values] of value) {
      lotsData.get(group).set(
        char,
        [...values].filter((el) => el.orderSupplierItem.type === "RAW_MATERIAL" || el.orderSupplierItem.type === "PACKAGING_CONSUMABLE")
      )
      if (lotsData.get(group).get(char).length === 0) {
        lotsData.get(group).delete(char)
      }
    }
    if (lotsData.get(group).size === 0) {
      lotsData.delete(group)
    }
  }

  return lotsData
} 

export const getLotInventoryErrorObject = () => {
  return {
    type: "LOT_INVENTORY_OPEN_DETAIL_SNACKBAR",
    inventoryOutputSnackBar: {
      open: true,
      duration: 5000,
      type: "error",
      message: "Erreur lors du téléchargement de l'inventaire.",
    },
  }
}

export const getLotsIngredientIds = (lotsData) => {
  let ids = []
  if (lotsData) {
    for (const [, value] of lotsData) {
      for (const [, values] of value) {
        values.forEach((elm) => ids.push(elm.orderSupplierItem.supplierItemId))
      }
    }
  }
  return ids
}

export const cleanHypotheticalLots = (lots, hypotheticalLotRemoved) => {
  for (const [group, value] of lots) {
    for (const [char, values] of value) {
      values.forEach((currentLot, index) => {
        if (
          currentLot.hypothetical &&
          currentLot.objectId === hypotheticalLotRemoved.objectId
        ) {
          lots.get(group).get(char).splice(index, 1)
          if (lots.get(group).get(char).length === 0) {
            lots.get(group).delete(char)
            if (lots.get(group).size === 0) {
              lots.delete(group)
            }
          }
        }
      })
    }
  }
}

export const getQuantitySubstituteAlreadyOutput = (
  allSubstituteLots,
  supplierItemId,
  date
) => {
  let quantitySubstituteOutput = 0
  allSubstituteLots.forEach((substituteLot) => {
    const weight =
      substituteLot.orderSupplierItem &&
      substituteLot.orderSupplierItem.units &&
      substituteLot.orderSupplierItem.units.stock.weight
        ? substituteLot.orderSupplierItem.units.stock.weight
        : 1
    substituteLot.events.forEach((event) => {
      if (
        event.mode === "OUTPUT" &&
        event.productionDate === date &&
        event.originalSupplierItem &&
        event.originalSupplierItem.objectId === supplierItemId
      ) {
        quantitySubstituteOutput += event.quantity * weight
      }
    })
  })

  return quantitySubstituteOutput
}

/**
 * Reconstructs the initial quantity of a lot based on its event history.
 * This function walks through the lot's events in reverse chronological order
 * and undoes the effects of each event to estimate what the original quantity was.
 */
export  const computeInitialQuantityFromEvents = (lot) => {
	if (!lot || !Array.isArray(lot.events)) return 0
	const sortedEvents = [...lot.events].sort((a, b) => a.date - b.date)

	return sortedEvents.reduceRight((currentQuantity, event) => {
		switch (event.mode) {
			case LOT_RECEPTION_MODE:
			case LOT_INVENTORY_MODE:
				return event.quantity
			case LOT_OUTPUT_MODE:
			case LOT_DAMAGE_MODE:
			case LOT_DISPATCH_MODE:
				return currentQuantity + event.quantity
			case LOT_RETURN_MODE:
				return currentQuantity - event.quantity
			default:
				return currentQuantity
		}
	}, lot.quantity || 0)
}